import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    viewAll: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label to show all results in a section */
            viewAll: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchSectionHeader.viewAll?c=6vjm8bbr517u", defaultMessage: "Show all" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
